<template>
  <div class="m-write-msg" data-title="申请流程">
    <applyPartner>
      <template v-slot:top>
        <p class="title">
          申请商家
        </p>
      </template>
      <template v-slot:left>
        <dl class="contract">
          <dt>
            <img src="../../assets/images/partner-img/1.png" alt="">
          </dt>
          <dd>
            签约合同
          </dd>
        </dl>
      </template>
      <template v-slot:right>
        <dl class="prove">
          <dt>
            <img src="../../assets/images/partner-img/2.png" alt="">
          </dt>
          <dd>
            完成认证
          </dd>
        </dl>
      </template>
    </applyPartner>
    <!-- 姓名 -->
    <section>
      <!-- <van-tabs v-model="active">
        <van-tab title="标签 1">内容 1</van-tab>
        <van-tab title="标签 2">内容 2</van-tab>
      </van-tabs> -->
      <div class="partner-information">
        <van-tabs v-model="active" 
          color="white"
          title-active-color="#212121"
          title-inactive-color="#A9A9A9"
        >
          <van-tab title="企业" >
            <enterpriseInformation></enterpriseInformation>
          </van-tab>
          <van-tab title="个人">
            <personalDetails></personalDetails>
          </van-tab>
        </van-tabs>
      </div>
    </section>

    <van-popup v-model="showAddress" position="bottom" :style="{ height: '40%' }">
      <van-area 
        title="标题" 
        :area-list="addressList"
        @confirm="sure"
        @cancel="exit"
        />
    </van-popup>
  </div>
  
</template>

<script>


import applyPartner from '../../components/partner/apply-partner'
import addressList from '../../../public/addressList/area.js'
import enterpriseInformation from '../../components/merchant/enterprise-information'
import personalDetails from '../../components/merchant/personal-details'

import Vue from 'vue';
import { Field, Area, Popup, Tab, Tabs } from 'vant';

Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Popup);
Vue.use(Area);
Vue.use(Field);

export default {
  data(){
    return{
      name: '',
      phone : '',
      idcard : '',
      addressList : addressList,
      showAddress : false,
      aaa: '',
      active: 0,
    }
  },
  components:{
    applyPartner,
    enterpriseInformation,
    personalDetails
  },
  methods:{
    sure(val){
      this.showAddress = false
      // console.log(val)
      this.aaa = val[0].name + val[1].name + val[2].name;
      // console.log(this.userlist)
    },
    exit(){
      this.showAddress = false
    },
  }
}
</script>

<style lang="less" scoped>
  .m-write-msg{
    width: 7.5rem;
    display: flex;
    flex-direction: column;
    background-image: url('../../assets/images/partner-img/bag@2x.png');
    background-size: 100% 100%;
    // 信息
    section{
      .partner-information{
        width: 7.1rem;
        height: 14.11rem;
        background: #ffffff;
        margin: 0 auto;
        margin-top: .1rem;
        border-radius: .1rem;
      }
    }
  }
</style>

